import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import usePageTitle from '../../hooks/usePageTitle';

type WindowWithDataLayer = Window & {
  dataLayer: Record<string, any>[];
  gtag: (...args: any[]) => void;
};

declare const window: WindowWithDataLayer;

const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

const GoogleAnalytics: React.FC = () => {
  const location = useLocation();
  const pageTitle = usePageTitle();

  useEffect(() => {
    if (measurementId && window.gtag) {
      const eventProperties = {
        page_title: pageTitle,
        page_path: location.pathname,
        page_location: window.location.href,
        domain: window.location.hostname,
      };
      window.gtag('event', 'page_view', eventProperties);
    }
  }, [pageTitle]);

  return null;
};

export default GoogleAnalytics;
